import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Opens the process slideout when request for apply rules is triggered
 */
export const openProcessesSlideout = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.apply.request
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.processesFeature.actions.openSlideout.from(action).create(),
        ),
      ),
)
